import { request } from '@/utils/request'

// 获取首页banner广告列表
export function getAdvertiseList(query) {
  return request({
    url: '/advertise-info/notAuth/getAdvertiseList',
    method: 'get',
    params: query
  })
}

// 新增官网收集信息
export function infomationAdd(params) {
  return request({
    url: '/officialWebsiteInformationCollection/notAuth/add',
    method: 'post',
    data: params
  })
}

// 新增官网收集信息
export function informationCollection(params) {
  return request({
    url: '/officialWebsiteInformationCollection/notAuth/officialWebsiteInformationCollection',
    method: 'post',
    data: params
  })
}

// 新增官网收集信息
export function simpleInformationCollection(params) {
  return request({
    url: '/officialWebsiteInformationCollection/notAuth/officialWebsiteSimpleInformationCollection',
    method: 'post',
    data: params
  })
}

// 发送短信验证码
export function sendSmsCaptcha(params) {
  return request({
    url: '/officialWebsiteInformationCollection/notAuth/sendSmsCaptcha',
    method: 'post',
    data: params
  })
}

// 官网浏览量计数
export function browseCount() {
  return request({
    url: '/officialWebsiteInformationCollection/notAuth/browseCount',
    method: 'get',
    params: {}
  })
}

// 发送短信验证码
export function getImgCaptcha() {
  return request({
    url: '/notAuth/getImgCaptcha',
    method: 'get',
    params: {}
  })
}

// 发送短信验证码
export function sendSmsCaptchaCheckImg(params) {
  return request({
    url: '/officialWebsiteInformationCollection/notAuth/sendSmsCaptchaCheckImg',
    method: 'post',
    data: params
  })
}

// 获取官网资讯列表
export function getOfficialWebsiteInfomationList(params) {
  return request({
    url: '/infomation/notAuth/getOfficialWebsiteInfomationList',
    method: 'get',
    params: params
  })
}

// 根据编号获取资讯详情
export function getOfficialWebsiteInfomationInfo(id) {
  return request({
    url: '/infomation/notAuth/getOfficialWebsiteInfomationInfo',
    method: 'get',
    params: { infoNo: id }
  })
}

// 获取官网案例列表
export function getOfficialWebsiteCaseList(secondCategoryName) {
  return request({
    url: '/case/notAuth/getOfficialWebsiteCaseList',
    method: 'get',
    params: { secondCategoryName }
  })
}

// 获取新闻中心列表
export function getNewsList(data) {
  return request({
    url: 'getWebsiteNewsInfoList',
    method: 'get',
    params: data
  })
}

// 获取首页banner
export function getWebsiteBannerInfoList() {
  return request({
    url: 'getWebsiteBannerInfoList',
    method: 'get'
  })
}
